import React, { useEffect, useState } from 'react'
import { api } from '../../../../../utils'
import { SISTEMIPAGAMENTO } from '../../../../../utils/endpoint'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import { trackingCheckout } from '../../../../../utils/gtm'
import useTrans from '../../../../../hooks/useTrans'
import { useRouter } from 'next/router'
import * as Sentry from '@sentry/browser'
import { useSelector } from 'react-redux'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'
import { CheckoutOption } from '../../../../molecules'

const ModalitaPagamento = ({ props, step, setStep, carrello_main, Submit }) => {
  const t = useTrans()
  const router = useRouter()

  const [opzioniPagamento, setOpzioniPagamento] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    api
      .get(SISTEMIPAGAMENTO, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => {
        const newOpzioniPagamento = props.values.utente?.guest
          ? res?.data?.filter((x) => x.tipologie_utenti.includes(props.values?.utente?.tipologia))
          : res?.data || []
        setOpzioniPagamento(newOpzioniPagamento)
        props.setFieldValue('opzioni_pagamento', newOpzioniPagamento)
        // Seleziono metodo di pagamento predefinito dell'utente
        if (newOpzioniPagamento?.find((x) => x.id === props.values.utente.sistema_pagamento)) {
          props.setFieldValue(
            'id_modalita_pagamento',
            newOpzioniPagamento?.find((x) => x.id === props.values.utente.sistema_pagamento)?.id ||
              null
          )
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err)
        Sentry.captureException(err)
      })
  }, [])

  if (loading) {
    return <LoadingSvg />
  }

  return (
    <div className="checkout__pagamento">
      <FormField className="checkout__formfield">
        {opzioniPagamento.map((opzione) => (
          <CheckoutOption
            key={opzione.id}
            title={opzione?.nome || opzione?.descrizione}
            description={!opzione?.nome ? null : opzione?.descrizione}
            moreContent={
              opzione?.iban ? (
                <p className="checkout__pagamento__more-content">
                  <strong>IBAN:</strong> {opzione.iban}
                </p>
              ) : null
            }
            checked={props.values.id_modalita_pagamento === opzione.id}
            onClick={() => props.setFieldValue('id_modalita_pagamento', opzione.id)}
            fullClick
          />
        ))}
      </FormField>

      {(!props.values.utente?.guest || props.values.with_registrazione) &&
        props.values.id_modalita_pagamento !== null &&
        props.values.utente.sistema_pagamento != props.values.id_modalita_pagamento && (
          <FormField className="checkout__formfield">
            <FormCheckbox
              label={t('Usa come predefinito il metodo di pagamento selezionato')}
              onChange={() =>
                props.setFieldValue(
                  'id_modalita_pagamento_predefinita',
                  !props.values.id_modalita_pagamento_predefinita
                )
              }
              checked={props.values.id_modalita_pagamento_predefinita}
              onBlur={props.handleBlur('id_modalita_pagamento_predefinita')}
            />
          </FormField>
        )}

      {props.values.id_modalita_pagamento !== null && (
        <Button
          disabled={props.isValid ? false : true}
          label={t('Conferma pagamento')}
          variant="primary"
          size="medium"
          onClick={() => {
            setStep(step + 1)

            const payMethod = opzioniPagamento?.find(
              (opzione) => props.values.id_modalita_pagamento === opzione.id
            )?.nome
            trackingCheckout(carrello_main, 5, payMethod)

            Submit()
          }}
        />
      )}
    </div>
  )
}

export default ModalitaPagamento
